<template>
  <div class="content-8">
    <div style="position:relative">
      <div class="content-8__controlbar__item">
        <div class="c8-explanation">
          <span class="c8-explanation__title">说明：</span>
          <div class="c8-explanation__content">
            <p>1.用户一周内必须发起4单竞猜(含4单)才能满足上榜资格</p>
            <p>2.每周一到周日为一个排名周期，每周一开始重新计算战绩</p>
          </div>
        </div>
      </div>
      <div class="content-8__content">
        <div class="c13-leaderboard">
          <div class="c13-leaderboard__item">
            <div class="leaderboardbox">
              <div class="leaderboardbox__title red-bg">
                <div class="leaderboardbox__title__left">
                  <div class="c13-itemtitle"><span class="c13-itemtitle__text">连赢榜</span></div>
                </div>
                <div class="leaderboardbox__title__right">
                  <div class="c13-datebox">
                    <a class="button-primary  c13-datebox__item" :class="{'active':responseData.win.currentDate === 'thisWeek'}" href="" @click.prevent="selectDate('win','thisWeek')">
                      <span class="button-primary__text">本周</span>
                    </a>
                    <a class="button-primary c13-datebox__item" :class="{'active':responseData.win.currentDate === 'lastWeek'}" href="" @click.prevent="selectDate('win','lastWeek')">
                      <span class="button-primary__text">上周</span>
                    </a>
                  </div>
                </div>
              </div>
              <div v-if="responseData.win.topThreeData.length > 0 && !winLoading" class="leaderboardbox__content">
                <div class="c13-achievement">
                  <div class="c13-achievement__title">
                    <div v-for="(winData,idx) in responseData.win.topThreeData" :key="`win-top-${idx}`" class="c13-achievement__title__item">
                      <div class="c13-ranking" :class="{'special':winData.imgName == 1}">
                        <img class="c13-ranking__img" :src="require(`@/assets/desktop/img/rank-${winData.imgName}.svg`)">
                        <div class="c13-ranking__name"><span class="c13-ranking__name__text fn-pointer" @click="goMemberInfo(winData.userID)">{{ accountFormat(winData.userName) }}</span></div>
                        <div class="c13-ranking__number"><span class="c13-ranking__number__text red">{{ winData.score }}</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="c13-achievement__content">
                    <div v-for="(otherData,idx) in responseData.win.otherData" :key="`win-other-${idx}`" class="c13-achievement__content__item">
                      <div class="c13-ranking">
                        <div class="c13-ranking__sort"><span class="c13-ranking__sort__text">{{ idx+4 }}</span></div>
                        <div class="c13-ranking__name"><span class="c13-ranking__name__text fn-pointer" @click="goMemberInfo(otherData.userID)">{{ accountFormat(otherData.userName) }}</span></div>
                        <div class="c13-ranking__number"><span class="c13-ranking__number__text red">{{ otherData.score }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Loading v-if="winLoading" />
              <noData v-if="responseData.win.topThreeData.length == 0 && !winLoading" />
            </div>
          </div>
          <div class="c13-leaderboard__item">
            <div class="leaderboardbox">
              <div class="leaderboardbox__title blue-bg">
                <div class="leaderboardbox__title__left">
                  <div class="c13-itemtitle"><span class="c13-itemtitle__text">盈利榜</span></div>
                </div>
                <div class="leaderboardbox__title__right">
                  <div class="c13-datebox">
                    <a class="button-primary c13-datebox__item" :class="{'active':responseData.profit.currentDate === 'thisWeek'}" href="" @click.prevent="selectDate('profit','thisWeek')">
                      <span class="button-primary__text">本周</span>
                    </a>
                    <a class="button-primary c13-datebox__item" :class="{'active':responseData.profit.currentDate === 'lastWeek'}" href="" @click.prevent="selectDate('profit','lastWeek')">
                      <span class="button-primary__text">上周</span>
                    </a>
                  </div>
                </div>
              </div>
              <div v-if="responseData.profit.topThreeData.length > 0 && !profitLoading" class="leaderboardbox__content">
                <div class="c13-achievement">
                  <div class="c13-achievement__title">
                    <div v-for="(profitData,idx) in responseData.profit.topThreeData" :key="`profit-top-${idx}`" class="c13-achievement__title__item">
                      <div class="c13-ranking" :class="{'special':profitData.imgName == 1}">
                        <img class="c13-ranking__img" :src="require(`@/assets/desktop/img/rank-${profitData.imgName}.svg`)">
                        <div class="c13-ranking__name"><span class="c13-ranking__name__text fn-pointer" @click="goMemberInfo(profitData.userID)">
                          {{ accountFormat(profitData.userName) }}
                        </span></div>
                        <div class="c13-ranking__number"><span class="c13-ranking__number__text red">{{ profitData.amount }}</span></div>
                      </div>
                    </div>
                  </div>
                  <div class="c13-achievement__content">
                    <div v-for="(otherData,idx) in responseData.profit.otherData" :key="`profit-other-${idx}`" class="c13-achievement__content__item">
                      <div class="c13-ranking">
                        <div class="c13-ranking__sort"><span class="c13-ranking__sort__text">{{ idx+4 }}</span></div>
                        <div class="c13-ranking__name"><span class="c13-ranking__name__text fn-pointer" @click="goMemberInfo(otherData.userID)">{{ accountFormat(otherData.userName) }}</span></div>
                        <div class="c13-ranking__number"><span class="c13-ranking__number__text red">{{ otherData.amount }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Loading v-if="profitLoading" />
              <noData v-if="responseData.profit.topThreeData.length == 0 && !profitLoading" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { checkIsLogin_web } from '@/utils/member'
import { accountFormat } from '@/utils/commonLib'
import { rankingWins_web, rankingProfits_web } from '@/api/desktop/betLottery'
import Loading from '@/components/web/common/Loading'
import NoData from '@/components/web/common/NoData'
export default {
  name: 'Rank',
  components: {
    Loading,
    NoData
  },
  props: {
    cpType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      winLoading: true,
      profitLoading: true,
      isLoading: false,
      // responseData: [],
      currentDate: 'thisWeek',
      responseData: {
        win: {
          currentDate: 'thisWeek',
          topThreeData: [],
          otherData: []
        },
        profit: {
          currentDate: 'thisWeek',
          topThreeData: [],
          otherData: []
        }
      },
      typeList: [
        {
          value: 'win',
          label: '连赢榜'
        },
        {
          value: 'profit',
          label: '盈利榜'
        }
      ],
      dateList: [
        {
          value: 'thisWeek',
          label: '本周'
        },
        {
          value: 'lastWeek',
          label: '上周'
        }
      ]
    }
  },
  computed: {
    lotteryCode() {
      return this.$route.params.lottery_code
    },
    RankExplainationHtml() {
      return `<p>1.用户一周内必须发起4单竞猜(含4单)才能满足上榜资格</p><p>2.每周一到周日为一个排名周期，每周一开始重新计算战绩</p>`
    }
  },
  watch: {
    $route() {
      this.getWinList()
      this.getProfitList()
    }
  },
  mounted() {
    this.getWinList()
    this.getProfitList()
  },
  methods: {
    getRankImgPath(idx) {
      switch (idx) {
        case 0 :
          return "'@/assets/desktop/img/rank-2.svg'"
        case 1 :
          return "'@/assets/desktop/img/rank-1.svg'"
        case 2 :
          return "'@/assets/desktop/img/rank-3.svg'"
      }
    },
    async getWinList() {
      this.winLoading = true
      const [winData, WinError] = await rankingWins_web({ dateType: this.responseData.win.currentDate, pi: 1, ps: 20 })
      if (WinError) return
      if (winData.length > 0) {
        this.responseData.win.topThreeData = winData.slice(0, 3);
        [this.responseData.win.topThreeData[0], this.responseData.win.topThreeData[1]] = [this.responseData.win.topThreeData[1], this.responseData.win.topThreeData[0]]
        this.responseData.win.topThreeData.forEach((data, idx) => {
          switch (idx) {
            case 0:
              data.imgName = 2
              break
            case 1:
              data.imgName = 1
              break
            case 2:
              data.imgName = 3
              break
          }
        })
        this.responseData.win.otherData = winData.slice(3)
        this.winLoading = false
      } else {
        this.winLoading = false
      }
    },
    async getProfitList() {
      this.profitLoading = true
      const [profitData, profitError] = await rankingProfits_web({ dateType: this.responseData.profit.currentDate, pi: 1, ps: 20 })
      if (profitError) return
      if (profitData.length > 0) {
        this.responseData.profit.topThreeData = profitData.slice(0, 3);
        [this.responseData.profit.topThreeData[0], this.responseData.profit.topThreeData[1]] = [this.responseData.profit.topThreeData[1], this.responseData.profit.topThreeData[0]]
        this.responseData.profit.topThreeData.forEach((data, idx) => {
          switch (idx) {
            case 0:
              data.imgName = 2
              break
            case 1:
              data.imgName = 1
              break
            case 2:
              data.imgName = 3
              break
          }
        })
        this.responseData.profit.otherData = profitData.slice(3)
        this.profitLoading = false
      } else {
        this.profitLoading = false
      }
    },
    async goMemberInfo(userID) {
      if (await checkIsLogin_web(this)) {
        this.$router.push(`/lotterybet/lotteryhome/${this.cpType}/userInfo/${userID}`)
      }
    },
    accountFormat(member) {
      return accountFormat(member)
    },
    async getList(type) {
      this.isLoading = true

      const [winData, WinError] = await rankingWins_web({ dateType: this.currentDate, pi: 1, ps: 20 })
      const [profitData, profitError] = await rankingProfits_web({ dateType: this.currentDate, pi: 1, ps: 20 })

      if (WinError || profitError) return
      this.responseData.win.topThreeData = winData.slice(0, 3)
      this.responseData.win.otherData = winData.slice(3)
      this.responseData.profit.topThreeData = profitData.slice(0, 3)
      this.responseData.profit.otherData = profitData.slice(3)
      this.isLoading = false
    },
    selectType(type) {
      this.getList(type)
    },
    selectDate(type, date) {
      if (type === 'win') {
        this.responseData.win.currentDate = date
        this.getWinList()
      } else {
        this.responseData.profit.currentDate = date
        this.getProfitList()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .fn-pointer {
    cursor:pointer
  }
  .c8-explanation {
    height: auto;
  }
</style>
